function styleWishlistCardButtons() {
  document.querySelectorAll("ooo-wl-product-card-button").forEach((host) => {
    if (!host.shadowRoot || host.dataset.wlBgStyled) return;
    host.dataset.wlBgStyled = "true";
    const style = document.createElement("style");
    style.textContent = `
      button[aria-checked="true"] {
        background-color: #f00b87 !important;
      }
    `;
    host.shadowRoot.appendChild(style);
  });
}
styleWishlistCardButtons();
new MutationObserver(styleWishlistCardButtons).observe(document.body, {
  childList: true,
  subtree: true,
});
